import * as yup from 'yup';
import { addBusinessDays } from 'date-fns';
import { V1RecurringRuleInterval } from '@fintronners/react-api/src';
import { V1TradeExpirationType } from '@fintronners/react-api/src';
import { getOneOfEnumSchema } from '@fintronners/react-api/src/utils/formUtils/schemas/commonSchemas';
import { OrderType, QuantityType } from '@fintronners/internal-core/src/trade/constants';

export const intervals = [
  V1RecurringRuleInterval.EveryWeek,
  V1RecurringRuleInterval.EveryTwoWeeks,
  V1RecurringRuleInterval.EveryMonth,
];

export enum TradeSide {
  BUY = 'buy',
  SELL = 'sell',
}

export const tradeSchema = yup.object({
  orderType: getOneOfEnumSchema(OrderType)
    .when('$side', ([side], schema) =>
      schema.default(side === TradeSide.BUY ? OrderType.MARKET_BUY : OrderType.MARKET_SELL),
    )
    .required(),
  quantityType: getOneOfEnumSchema(QuantityType)
    .when('$isFractionable', ([isFractionable], schema) =>
      schema.default(isFractionable ? QuantityType.DOLLARS : QuantityType.SHARES),
    )
    .required(),
  amount: yup.string().default('0').required(),
  shares: yup.string().default('0').required(),
  duration: getOneOfEnumSchema(V1TradeExpirationType).default(V1TradeExpirationType.Day),
  limitPrice: yup.number(),
  interval: getOneOfEnumSchema(V1RecurringRuleInterval).default(V1RecurringRuleInterval.EveryWeek),
  selectedStartDate: yup.string().default(addBusinessDays(new Date(), 1).toISOString()),
  stopLoss: yup.string().default('0'),
});

export type TradeFormData = yup.InferType<typeof tradeSchema>;
